"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __extend_1 = __importDefault(require("./_.extend"));
const __hooks_fields_1 = __importDefault(require("./_.hooks.fields"));
// import { Field } from 'mobx-react-form';
// import { Field } from 'mobx-react-form/src';
const src_1 = require("../../modules/mobx-react-form/src"); // load from source (MASTER)
// import { Field } from '../../modules/mobx-react-form/lib'; // load from build (MASTER)
// forms
const markdown_1 = __importDefault(require("./setup/markdown"));
const fileUpload_1 = __importDefault(require("./setup/fileUpload"));
const nestedFields_1 = __importDefault(require("./setup/nestedFields"));
const registerSimple_1 = __importDefault(require("./setup/registerSimple"));
const registerMaterial_1 = __importDefault(require("./setup/registerMaterial"));
const companySimple_1 = __importDefault(require("./setup/companySimple"));
const companyWidgets_1 = __importDefault(require("./setup/companyWidgets"));
const dynamicFieldsSelect_1 = __importDefault(require("./setup/dynamicFieldsSelect"));
class CustomField extends src_1.Field {
    hooks() {
        return __hooks_fields_1.default;
    }
}
class RegisterMaterialForm extends __extend_1.default {
    makeField(field) {
        return new CustomField(field);
    }
}
class RegisterSimpleForm extends __extend_1.default {
}
class NestedFieldsForm extends __extend_1.default {
}
class MarkdownForm extends __extend_1.default {
}
class FileUploadForm extends __extend_1.default {
}
class CompanySimpleForm extends __extend_1.default {
}
class CompanyWidgetsForm extends __extend_1.default {
}
class FormDynamicFieldsSelect extends __extend_1.default {
}
const onSubmitFileUpload = (form) => {
    console.log('FileUpload > myFileUpload files', form.$('myFileUpload').files);
    console.log('FileUpload > myDropZone files', form.$('myDropZone').files);
};
exports.default = {
    nestedFields: new NestedFieldsForm(Object.assign({}, nestedFields_1.default), { name: 'Nested Fields' }),
    markdown: new MarkdownForm(Object.assign({}, markdown_1.default), { name: 'Markdown' }),
    fileUpload: new FileUploadForm(Object.assign({}, fileUpload_1.default), { hooks: { onSubmit: onSubmitFileUpload }, name: 'File Upload' }),
    registerMaterial: new RegisterMaterialForm(Object.assign({}, registerMaterial_1.default), { name: 'Register Material' }),
    registerSimple: new RegisterSimpleForm(Object.assign({}, registerSimple_1.default), { name: 'Register Simple' }),
    companySimple: new CompanySimpleForm(Object.assign({}, companySimple_1.default), { name: 'Company Simple' }),
    companyWidgets: new CompanyWidgetsForm(Object.assign({}, companyWidgets_1.default), { name: 'Company Widgets' }),
    dynamicFieldsSelect: new FormDynamicFieldsSelect(Object.assign({}, dynamicFieldsSelect_1.default), { name: 'Dynamic Fields Select' }),
};
